export const publicPages = [
  { path: "/support", title: "Support — ProximaForma", description: "Contact ProximaForma for account, connection, billing, and privacy support." },
  {
    path: "/connect/chatgpt",
    title: "Add to ChatGPT — ProximaForma",
    description: "Connect your ProximaForma canvas to ChatGPT on desktop or in your browser, and check mobile availability.",
  },
  {
    path: "/",
    title: "Proximaforma — Your ideas. Your agents. One canvas.",
    description:
      "A shared design workspace for people and AI agents. Create product interfaces on an editable canvas with a REST API and MCP server.",
  },
  {
    path: "/product",
    title: "The product — Proximaforma",
    description:
      "Private canvases, page navigation, shared feedback, live agent edits, and portable exports.",
  },
  {
    path: "/use-cases",
    title: "Ways to work — Proximaforma",
    description:
      "Explore interface concepts, refine product screens, and build repeatable design workflows with your AI agents.",
  },
  {
    path: "/integrations",
    title: "Bring your agents — Proximaforma",
    description:
      "Connect your tools to the design canvas with MCP over stdio or Streamable HTTP, or build directly with the REST API.",
  },
  {
    path: "/pricing",
    title: "Pricing — Proximaforma",
    description:
      "Start with 1,500 free Forma credits. Choose your payment currency with Stripe. Refill with prepaid credit priced from actual model usage plus markup.",
  },
  {
    path: "/docs",
    title: "Getting started — Proximaforma docs",
    description:
      "Run Proximaforma locally, make your first design, and connect an AI agent to the same workspace.",
  },
  {
    path: "/docs/mcp",
    title: "MCP setup and tools — Proximaforma docs",
    description:
      "Connect a local MCP client, configure Streamable HTTP, and use Proximaforma’s design and comment tools.",
  },
  {
    path: "/docs/api",
    title: "REST API reference — Proximaforma docs",
    description:
      "Create projects, add design elements, send atomic batches, handle revision conflicts, and export your work through the REST API.",
  },
  {
    path: "/docs/workspace",
    title: "Canvas guide — Proximaforma docs",
    description:
      "Learn frames, layers, keyboard shortcuts, precise editing, preview, and exports in the Proximaforma workspace.",
  },
  {
    path: "/changelog",
    title: "What’s new — Proximaforma",
    description:
      "Release notes for Proximaforma, including the local canvas, agent connections, and marketing pages.",
  },
  {
    path: "/privacy",
    title: "Your data — Proximaforma",
    description:
      "How ProximaForma stores account and design data, connects AI services, and handles privacy requests.",
  },
] as const;

export function normalizePath(path: string) {
  return path.replace(/\/+$/, "") || "/";
}

export function pageMetadata(path: string) {
  const normalized = normalizePath(path);
  return (
    publicPages.find((page) => page.path === normalized) ?? {
      path: normalized,
      title:
        normalized === "/app"
          ? "Workspace — Proximaforma"
          : "Page not found — Proximaforma",
      description:
        normalized === "/app"
          ? "Your shared design workspace for people and AI agents."
          : "Find your way back to Proximaforma’s product, documentation, or design workspace.",
    }
  );
}
